export const contactUsJson = {
  type: 'Page',
  options: {
    schema: {
      type: 'object',
      required: [
        'firstName',
        'lastName',
        'email',
        'phoneNumber',
        'company',
        'country',
        'typeOfQuery',
        'message',
      ],
      properties: {
        firstName: {
          type: 'string',
          pattern: '^(?!\\s*$).+',
          maxLength: 50,
        },
        lastName: {
          type: 'string',
          pattern: '^(?!\\s*$).+',
          maxLength: 50,
        },
        email: {
          type: 'string',
          pattern: "^(?=[\\w\\s])\\s*[-+.'\\w]+@[-.\\w]+\\.[a-zA-Z]+\\s*$",
          maxLength: 50,
        },
        phoneNumber: {
          type: 'string',
          pattern: '^[+]?[0-9 ()-]*(ext.)?[0-9 ()]*$',
          maxLength: 50,
        },
        company: {
          type: 'string',
          maxLength: 50,
          pattern: '^(?!\\s*$).+',
        },
        country: {
          type: 'string',
        },
        solution: {
          type: 'string',
        },
        typeOfQuery: {
          type: 'string',
          enum: [
            'General Question',
            'Explore Technology or Services',
            'Learn About Adobe Product',
            'Request for Proposal (RFP)',
          ],
        },
        message: {
          type: 'string',
          pattern: '^(?!\\s*$).+',
          maxLength: 5000,
        },
      },
    },
    uischema: {
      type: 'VerticalLayout',
      elements: [
        {
          type: 'HorizontalLayout',
          options: {
            style: {
              gap: '25px',
              wrap: true,
              flexWrap: 'wrap',
            },
          },
          elements: [
            {
              type: 'Control',
              scope: '#/properties/firstName',
              label: 'First Name',
              options: {
                errors: {
                  required: 'Required',
                  pattern: 'Required',
                },
              },
            },
            {
              type: 'Control',
              options: {
                errors: {
                  required: 'Required',
                  pattern: 'Required',
                },
              },
              label: 'Last Name',
              scope: '#/properties/lastName',
            },
          ],
        },
        {
          type: 'HorizontalLayout',
          options: {
            style: {
              gap: '25px',
              flexWrap: 'wrap',
            },
          },
          elements: [
            {
              type: 'Control',
              options: {
                errors: {
                  required: 'Required',
                  pattern: 'Invalid email address.',
                },
              },
              label: 'Email',
              scope: '#/properties/email',
            },
            {
              type: 'Control',
              label: 'Phone Number',
              scope: '#/properties/phoneNumber',
              options: {
                errors: {
                  required: 'Required',
                  pattern: 'Invalid phone number.',
                },
              },
            },
          ],
        },
        {
          type: 'HorizontalLayout',
          options: {
            style: {
              gap: '25px',
              flexWrap: 'wrap',
            },
          },
          elements: [
            {
              type: 'Control',
              scope: '#/properties/company',
              label: 'Company',
              options: {
                errors: {
                  required: 'Required',
                  pattern: 'Required',
                },
              },
            },
            {
              type: 'Control',
              scope: '#/properties/country',
              label: 'Country',
              options: {
                name: 'country',
                contextPicker: true,
                dataSource: {
                  type: 'context',
                  value: 'countries',
                },
                errors: {
                  required: 'Required',
                },
              },
            },
          ],
        },
        {
          type: 'Control',
          scope: '#/properties/solution',
          label: 'Adobe Product',
          options: {
            name: 'solution',
            contextPicker: true,
            dataSource: {
              type: 'context',
              value: 'solutions',
            },
            errors: {
              required: 'Required',
            },
          },
        },
        {
          type: 'Control',
          scope: '#/properties/typeOfQuery',
          label: 'Type of query',
          options: {
            errors: {
              required: 'Required',
            },
          },
        },
        {
          type: 'Control',
          scope: '#/properties/message',
          label: 'Message',
          options: {
            errors: {
              required: 'Required',
              pattern: 'Required',
            },
            multi: true,
            showMaxLength: true,
          },
        },
      ],
    },
  },
  data: {},
};

export default contactUsJson;
